'use client';

import { Spinner } from '@capra/core';
import * as React from 'react';
import styled from 'styled-components';

const SpinnerWrapperContainer = styled.div`
  height: 32px;
  padding: 16px 0;
`;

const SpinnerWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CustomSpin = () => (
  <SpinnerWrapperContainer>
    <SpinnerWrapper data-testid='custom-spin'>
      <Spinner size='lg' />
    </SpinnerWrapper>
  </SpinnerWrapperContainer>
);
